var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from "lit/decorators.js";
import { html, LitElement } from "lit";
import { ExchangeMethod } from "../../model/exchange_method.js";
import httpMethodCss from "./http-method.css.js";
let HttpMethodComponent = class HttpMethodComponent extends LitElement {
    constructor() {
        super();
        this.lower = false;
        this.method = 'GET';
    }
    render() {
        let size = 'medium';
        if (this.large) {
            size = 'large';
        }
        if (this.tiny) {
            size = 'small';
        }
        return html `
            <sl-tag variant="${ExchangeMethod(this.method)}" class="method ${size}" 
                    size="${size}">
                ${this.lower ? this.method.toLowerCase() : this.method.toUpperCase()}</sl-tag>
        `;
    }
};
HttpMethodComponent.styles = httpMethodCss;
__decorate([
    property()
], HttpMethodComponent.prototype, "method", void 0);
__decorate([
    property({ type: Boolean })
], HttpMethodComponent.prototype, "lower", void 0);
__decorate([
    property({ type: Boolean })
], HttpMethodComponent.prototype, "large", void 0);
__decorate([
    property({ type: Boolean })
], HttpMethodComponent.prototype, "tiny", void 0);
HttpMethodComponent = __decorate([
    customElement('pb33f-http-method')
], HttpMethodComponent);
export { HttpMethodComponent };
